import { matcher, MatchType } from "@cdv/jazz-ui";
import View from "../ui/View";
import Content from "./Content";
import { Resource } from "../utils";

export default matcher({ resource: Resource.Homepage }).set(MatchType.View, Content).entries();
